import { StreamType } from './types';
export var reduxKey = '@@streams';
export var actionKey = 'STREAM';
export var defaultStreamState = {
    streamId: '',
    streamType: StreamType.WITH_CURSOR,
    items: [],
    itemsPerFetch: 0,
    hasMore: false,
    hasLess: false,
};
//# sourceMappingURL=constants.js.map